var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "role" },
    [
      _c(
        "el-tabs",
        {
          staticClass: "my-tabs",
          attrs: {
            value: _vm.showAuthPage ? "auth" : "distribute",
            "before-leave": _vm.distributeGetMember
          }
        },
        [
          _vm.showAuthPage
            ? _c(
                "el-tab-pane",
                { attrs: { label: "角色权限", name: "auth" } },
                [
                  _c(
                    "el-container",
                    [
                      _c(
                        "el-aside",
                        { staticClass: "user-menu", attrs: { width: "200px" } },
                        [
                          _c(
                            "el-row",
                            { staticStyle: { padding: "15px" } },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "user-icon",
                                  attrs: { span: 12 }
                                },
                                [_vm._v("角色")]
                              ),
                              _c(
                                "el-col",
                                {
                                  staticClass: "user-add",
                                  attrs: { span: 12 },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.showAddRole = true
                                    }
                                  }
                                },
                                [_vm._v("添加角色")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-menu",
                            {
                              staticClass: "el-menu-vertical-demo my-menu",
                              attrs: {
                                "text-color": "rgb(102,102,102)",
                                "active-text-color": "#EC1C1C"
                              },
                              on: { select: _vm.getOneRole }
                            },
                            _vm._l(_vm.roles, function(role, index) {
                              return _c(
                                "el-menu-item",
                                {
                                  key: index,
                                  staticStyle: {
                                    "overflow-x": "hidden",
                                    "text-overflow": "ellipsis",
                                    "text-align": "center",
                                    height: "46px",
                                    "line-height": "46px"
                                  },
                                  attrs: {
                                    title: role.roleName,
                                    id: "roleMenu" + index,
                                    index: role.corpRoleId + ""
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(role.roleName) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-main",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.rolesLoading,
                              expression: "rolesLoading"
                            }
                          ]
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "each-field" },
                            [
                              _c("span", { staticClass: "require" }, [
                                _vm._v("*")
                              ]),
                              _vm._v(
                                "\n              角色名称：\n              "
                              ),
                              _c("el-input", {
                                staticClass: "common-inputs",
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.inputUserInfo.username,
                                  callback: function($$v) {
                                    _vm.$set(_vm.inputUserInfo, "username", $$v)
                                  },
                                  expression: "inputUserInfo.username"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "each-field" },
                            [
                              _c("span", { staticClass: "require" }, [
                                _vm._v("*")
                              ]),
                              _vm._v(
                                "\n              角色描述：\n              "
                              ),
                              _c("el-input", {
                                staticClass: "common-textarea",
                                staticStyle: { "vertical-align": "top" },
                                attrs: {
                                  type: "textarea",
                                  rows: "3",
                                  placeholder: "100字以内",
                                  maxlength: "100"
                                },
                                model: {
                                  value: _vm.inputUserInfo.userDescription,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.inputUserInfo,
                                      "userDescription",
                                      $$v
                                    )
                                  },
                                  expression: "inputUserInfo.userDescription"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "inputs-length",
                                  style: {
                                    color:
                                      _vm.inputUserInfo.userDescription
                                        .length >= 100
                                        ? "red"
                                        : "#606266"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.inputUserInfo.userDescription.length +
                                        "/ 100"
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "each-field",
                              staticStyle: { "min-height": "65%" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "require",
                                  staticStyle: { visibility: "hidden" }
                                },
                                [_vm._v("*")]
                              ),
                              _vm._v(
                                "\n              权限分配：\n              "
                              ),
                              _c(
                                "div",
                                { staticClass: "auth-wrapper" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "each-auth" },
                                    _vm._l(_vm.permEnum, function(item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "each-role"
                                        },
                                        [
                                          _c(
                                            "console-check",
                                            {
                                              staticClass: "roles-wrapper",
                                              staticStyle: { height: "100%" },
                                              attrs: { checkObj: item }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "auth-info",
                                                  attrs: { slot: "template" },
                                                  slot: "template"
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    { staticClass: "info" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.name)
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        { staticClass: "des" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.des)
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  ),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "each-auth",
                                      attrs: { span: 24 }
                                    },
                                    [
                                      _c("p", { staticClass: "info" }, [
                                        _c("span", { staticClass: "title" }, [
                                          _vm._v("角色分配")
                                        ]),
                                        _c("span", { staticClass: "des" }, [
                                          _vm._v("将角色分配给相应的成员")
                                        ])
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "handles" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "each-handle" },
                                            [
                                              _c(
                                                "el-checkbox",
                                                {
                                                  on: {
                                                    change:
                                                      _vm.handleCheckChangeAllRole
                                                  },
                                                  model: {
                                                    value: _vm.checkedAllRole,
                                                    callback: function($$v) {
                                                      _vm.checkedAllRole = $$v
                                                    },
                                                    expression: "checkedAllRole"
                                                  }
                                                },
                                                [_vm._v("所有角色")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._l(
                                            _vm.oneRoleInfo.roleJson,
                                            function(item, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass: "each-handle"
                                                },
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        checked:
                                                          item.operType == 1
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleCheckChange(
                                                            $event,
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.oneRoleInfo
                                                              .roleDistribute[
                                                              index
                                                            ].roleName
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "bottom-field" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini" },
                                  on: { click: _vm.delRole }
                                },
                                [_vm._v("删除")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: { click: _vm.saveRole }
                                },
                                [_vm._v("保存")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.showDistributePage
            ? _c(
                "el-tab-pane",
                {
                  staticClass: "distribute-pannel",
                  attrs: { label: "角色分配", name: "distribute" }
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form",
                                {
                                  staticClass: "filter-form",
                                  attrs: {
                                    inline: true,
                                    model: _vm.filterModel
                                  }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "关键字" } },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "220px" },
                                        attrs: {
                                          size: "mini",
                                          placeholder:
                                            "姓名/企业名称/邮箱/手机号"
                                        },
                                        model: {
                                          value: _vm.filterModel.targetId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterModel,
                                              "targetId",
                                              $$v
                                            )
                                          },
                                          expression: "filterModel.targetId"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "角色" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            size: "mini",
                                            placeholder: "请选择角色"
                                          },
                                          model: {
                                            value: _vm.filterModel.corpRoleId,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filterModel,
                                                "corpRoleId",
                                                $$v
                                              )
                                            },
                                            expression: "filterModel.corpRoleId"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: { label: "全部", value: "" }
                                          }),
                                          _vm._l(_vm.roles, function(
                                            role,
                                            index
                                          ) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: role.roleName,
                                                value: role.corpRoleId
                                              }
                                            })
                                          })
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { size: "mini" },
                                          on: { click: _vm.queryTool }
                                        },
                                        [_vm._v("搜索")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.distributeRoleLoading,
                                  expression: "distributeRoleLoading"
                                }
                              ],
                              ref: "multipleTable",
                              attrs: {
                                data: _vm.memberList,
                                border: "",
                                "tooltip-effect": "dark"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "姓名/企业名称",
                                  prop: "userName",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "账号(手机/邮箱)",
                                  prop: "targetId",
                                  "show-overflow-tooltip": ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          scope.row.targetId
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(scope.row.targetId) +
                                                    "\n                  "
                                                )
                                              ])
                                            : _c("span", [_vm._v("--")])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3792135025
                                )
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "部门",
                                  prop: "groupNames",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "角色", prop: "roleNames" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "类型", prop: "useType" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          scope.row.useType === 0
                                            ? _c("p", [
                                                _vm._v(
                                                  "\n                    个人\n                  "
                                                )
                                              ])
                                            : _vm._e(),
                                          scope.row.useType === 1
                                            ? _c("p", [
                                                _vm._v(
                                                  "\n                    企业\n                  "
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3137182398
                                )
                              }),
                              _c("el-table-column", {
                                attrs: { label: "操作" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "mini"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleDistribute(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("分配")]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2226930647
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { staticClass: "pageation" },
                        [
                          _c(
                            "el-col",
                            {
                              staticClass: "page-flex-end",
                              staticStyle: { padding: "30px 0" },
                              attrs: { span: 24 }
                            },
                            [
                              _c("el-pagination", {
                                attrs: {
                                  "current-page": _vm.filterModel.itemPage,
                                  "page-sizes": [10, 20, 50, 100],
                                  "page-size": _vm.filterModel.pageSize,
                                  layout: "sizes, prev, pager, next, total",
                                  total: _vm.filterModel.pageTotal
                                },
                                on: {
                                  "size-change": _vm.handleSizeChange,
                                  "current-change": _vm.handleCurrentChange
                                }
                              }),
                              _c("el-go", {
                                attrs: {
                                  "page-size": _vm.filterModel.pageSize,
                                  total: _vm.filterModel.pageTotal
                                },
                                on: {
                                  "current-change": _vm.handleCurrentChange
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showAddRole,
                expression: "showAddRole"
              }
            ],
            staticClass: "add-role-back"
          },
          [
            _c("div", {
              staticClass: "background",
              on: { click: _vm.closeAddRole }
            }),
            _c("div", { staticClass: "add-role" }, [
              _c("div", { staticClass: "head" }, [
                _vm._v("\n            添加角色\n            "),
                _c("i", {
                  staticClass: "el-icon-close",
                  on: { click: _vm.closeAddRole }
                })
              ]),
              _c("div", { staticClass: "body" }, [
                _c(
                  "div",
                  { staticClass: "add-role-field" },
                  [
                    _c("span", { staticClass: "require" }, [_vm._v("*")]),
                    _vm._v("\n              角色名称：\n              "),
                    _c("el-input", {
                      staticClass: "role-input",
                      attrs: { maxlength: "15", placeholder: "请输入" },
                      model: {
                        value: _vm.addRoleInfo.username,
                        callback: function($$v) {
                          _vm.$set(_vm.addRoleInfo, "username", $$v)
                        },
                        expression: "addRoleInfo.username"
                      }
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "inputs-length input",
                        style: {
                          color:
                            _vm.addRoleInfo.username.length >= 15
                              ? "red"
                              : "#606266"
                        }
                      },
                      [_vm._v(_vm._s(_vm.addRoleInfo.username.length + "/ 15"))]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "add-role-field" },
                  [
                    _c("span", { staticClass: "require" }, [_vm._v("*")]),
                    _vm._v("\n              角色描述：\n              "),
                    _c("el-input", {
                      staticClass: "role-textarea",
                      staticStyle: { "vertical-align": "top" },
                      attrs: {
                        type: "textarea",
                        rows: "3",
                        placeholder: "100字以内",
                        maxlength: "100"
                      },
                      model: {
                        value: _vm.addRoleInfo.userDescription,
                        callback: function($$v) {
                          _vm.$set(_vm.addRoleInfo, "userDescription", $$v)
                        },
                        expression: "addRoleInfo.userDescription"
                      }
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "inputs-length",
                        style: {
                          color:
                            _vm.addRoleInfo.userDescription.length >= 100
                              ? "red"
                              : "#606266"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.addRoleInfo.userDescription.length + "/ 100"
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "foot" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.closeAddRole }
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.addRole }
                    },
                    [_vm._v("确定")]
                  )
                ],
                1
              )
            ])
          ]
        )
      ]),
      _c(
        "el-dialog",
        {
          staticClass: "custom-table",
          attrs: {
            width: "50%",
            top: "10vh",
            title: "角色分配",
            visible: _vm.showDistribute
          },
          on: {
            "update:visible": function($event) {
              _vm.showDistribute = $event
            },
            close: function($event) {
              return _vm.clearSelection("roleSelection")
            }
          }
        },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "10px", "margin-top": "-10px" } },
            [_vm._v("部门：" + _vm._s(_vm.distibuteInfo.groupNames))]
          ),
          _c("el-row", { staticStyle: { "margin-bottom": "10px" } }, [
            _vm._v("姓名：" + _vm._s(_vm.distibuteInfo.userName))
          ]),
          _c(
            "el-row",
            [
              _vm.distibuteInfo.type == 0
                ? [_vm._v("手机：" + _vm._s(_vm.distibuteInfo.accout))]
                : _vm.distibuteInfo.type == 1
                ? [_vm._v("邮箱：" + _vm._s(_vm.distibuteInfo.accout))]
                : _vm._e()
            ],
            2
          ),
          _c(
            "el-row",
            [
              _c("el-row", [_vm._v("角色：")]),
              _c(
                "el-table",
                {
                  ref: "roleSelection",
                  attrs: {
                    data: _vm.distributeRoles,
                    "default-sort": { prop: "corpRoleId", order: "ascending" },
                    border: ""
                  },
                  on: { "selection-change": _vm.distributeRoleSelect }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      property: "roleName",
                      label: "角色名称",
                      width: "200"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { property: "groupName", label: "权限范围" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "140" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.chooseAuth(scope.row)
                                  }
                                }
                              },
                              [_vm._v("选择权限范围")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.showDistribute = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.doDistribute }
                },
                [_vm._v("确定")]
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "选择权限范围",
                visible: _vm.showChooseAuth,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.showChooseAuth = $event
                }
              }
            },
            [
              _c("el-tree", {
                attrs: {
                  data: _vm.treeGroup,
                  "node-key": "corpGroupId",
                  "default-expanded-keys": _vm.treeGroupKeys,
                  "highlight-current": true,
                  props: _vm.defaultProps
                },
                on: { "node-click": _vm.checkGroup }
              }),
              _c(
                "el-row",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.showChooseAuth = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.doChooseAuth }
                    },
                    [_vm._v("确定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c55f827", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c55f827","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/role.vue
// module id = YkaK
// module chunks = 135